module.exports = __webpack_public_path__ + "media/volvo/assets/images/healthcheck-77972bbcad1f6b1e87015d182632d294.jpg";